module.exports = __webpack_public_path__ + "img/1F1EF-1F1F5.550b37fb.svg";